var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsStateSelect',{attrs:{"value":_vm.C_value,"items":_vm.items},on:{"input":function($event){return _vm.$_onInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }